import { Form } from 'react-bootstrap'
import { Path, useFormContext } from 'react-hook-form'
import { IntegrationSettings } from '../../../schema'
import { Tooltip } from '../../../../../../../components/Tooltip/Tooltip'

export interface HouseholdCheckboxProps {
  mappingPath: string
  isDisabled?: boolean
  onChange?: () => void
  tooltip?: string
}

export const HouseholdCheckbox: React.FC<HouseholdCheckboxProps> = ({ mappingPath, isDisabled = false, onChange, tooltip }) => {
  const { watch, setValue } = useFormContext<IntegrationSettings>()

  const isHouseholdPath = `${mappingPath}.isHousehold` as Path<IntegrationSettings>
  const isHousehold = watch(isHouseholdPath) as boolean | undefined | null

  const onChangeRollUpToHousehold = (checked: boolean) => {
    setValue(isHouseholdPath, checked, { shouldDirty: true, shouldValidate: true })
    onChange?.()
  }

  const checkbox = (
    <Form.Check
      key={isHouseholdPath + '.updatable'}
      type='checkbox'
      id={isHouseholdPath + '.updatable'}
      label='Roll up to Household'
      checked={isHousehold ?? false}
      onChange={(e) => onChangeRollUpToHousehold(e.target.checked)}
      disabled={isDisabled}
    />
  )

  if (!tooltip) {
    return checkbox
  }

  return (
    <div className='d-flex align-items-center'>
      {checkbox}
      <Tooltip title={tooltip}>
        <i className='bi bi-info-square ms-1 zocks-text-gray-600' />
      </Tooltip>
    </div>
  )
}
